<template>
  <div class="container">

    <div class="matterHeader">
      <button @click="$router.go(-1)" class="btn btn-link"><i class="icon icon-back"></i><span>Back</span></button>
      <h4 v-if="visatype" class="panel-title">{{matter.username}} ({{matter.mattername}})</h4>

      <!-- SECTION TABS -->
      <div class="panel-nav" style="margin-right:1em;">
        <ul class="tab">
          <li class="tab-item" :class="{active: secKey === 'notes'}">
            <a href="" @click.prevent="secKey = 'notes'">Notes</a>
          </li>
          <li class="tab-item" :class="{active: secKey === 'docs'}">
            <a href="" @click.prevent="secKey = 'docs'">Documents</a>
          </li>
          <li v-for="(section, key) in visatype.sections" class="tab-item" :class="{active: secKey === key}">
            <a href="" @click.prevent="secKey = key">{{section.name}}</a>
          </li>
        </ul>
      </div>
      <!-- END SECTION TABS -->
    </div>

    <div class="matterHolder">
      <div>

        <div v-if="secKey === 'notes'">
          <quillEditor v-model="notes" :options="editorOptions" />
        </div>

        <div class="panel-body" v-if="visatype && matter && section">

          <!-- SUBSECTION LOOP -->
          <div v-for="sub in section.subsections">
            <div v-if="visible(sub)">

              <!-- REPEAT LOOP -->
              <div v-for="n in subcounts[sub.ref]" class="panel" style="margin-top:10px;">
                <div class="panel-header">
                  <div class="panel-title">
                    <h3>{{sub.name}} <span v-if="n > 1">({{n}})</span></h3>
                  </div>
                </div>
                <div class="panel-body">
                  <div v-for="q in sub.questions" :key="q.ref" v-show="q.dependent ? visible(q) : true">
                    <textQ v-if="q.type === 'text'" :matter="matter" :question="q" :answers="answers" :num="n" v-on:saved="addAns" v-on:edited="editAns"></textQ>
                    <boolQ v-else-if="q.type === 'yn'" :matter="matter" :question="q" :answers="answers" :num="n" v-on:saved="addAns" v-on:edited="editAns"></boolQ>
                    <selectQ v-else-if="q.type === 'select'" :matter="matter" :question="q" :answers="answers" :num="n" v-on:saved="addAns" v-on:edited="editAns"></selectQ>
                    <dateQ v-else-if="q.type === 'date'" :matter="matter" :question="q" :answers="answers" :num="n" v-on:saved="addAns" v-on:edited="editAns"></dateQ>
                    <numberQ v-else-if="q.type === 'number'" :matter="matter" :question="q" :answers="answers" :num="n" v-on:saved="addAns" v-on:edited="editAns"></numberQ>
                    <textareaQ v-else-if="q.type === 'textarea'" :matter="matter" :question="q" :answers="answers" :num="n" v-on:saved="addAns" v-on:edited="editAns"></textareaQ>
                    <countryQ v-else-if="q.type === 'country'" :matter="matter" :question="q" :answers="answers" :num="n" v-on:saved="addAns" v-on:edited="editAns"></countryQ>
                    <languageQ v-else-if="q.type === 'language'" :matter="matter" :question="q" :answers="answers" :num="n" v-on:saved="addAns" v-on:edited="editAns"></languageQ>
                  </div>
                </div>
                <button v-if="sub.repeatable && n === subcounts[sub.ref]" @click="addSub(sub)" class="btn btn-sm btn-primary float-right" style="width:155px">
                  <i class="icon icon-plus"></i>Add another
                </button>
              </div>
              <!-- END REPEAT LOOP -->

            </div>
          </div>
          <!-- END SUBSECTION LOOP -->

        </div>

        <!-- DOCUMENTS TAB -->
        <div v-else-if="secKey === 'docs'">

          <div v-for="doctype in visatype.doctypes" class="panel panel-docs">
            <div class="panel-header">
              <div class="panel-title">
                {{doctype.name}}
                <span v-if="!files[doctype.ref] || !files[doctype.ref].length" class="label label-default">
                  no uploads
                </span>
              </div>
            </div>
            <div class="panel-body">
              <div v-for="file in files[doctype.ref]" class="tile tile-centered">
                <div class="tile-icon">
                  <button class="btn btn-primary">
                    <i class="icon" :class="[file.accepted ? 'icon-check' : 'icon-cross']"></i>
                  </button>
                </div>
                <div class="tile-content">
                  <div class="tile-title">{{file.name}}</div>
                  <div class="tile-subtitle text-gray">{{dateStr(file.date)}}</div>
                </div>
                <div class="tile-action">
                  <div class="form-group">
                    <label class="form-switch">
                      <input type="checkbox" v-model="file.accepted" @change="saveMatter">
                      <i class="form-icon"></i> Accept
                    </label>
                  </div>
                </div>
              </div>

            </div>
          </div>

        </div>
        <!-- END DOCUMENTS TAB -->

      </div>
    </div>

  </div>
</template>

<script>

import axios from 'axios'
import textQ from '@/components/questions/text'
import boolQ from '@/components/questions/bool'
import selectQ from '@/components/questions/select'
import dateQ from '@/components/questions/date'
import numberQ from '@/components/questions/number'
import textareaQ from '@/components/questions/textarea'
import countryQ from '@/components/questions/country'
import languageQ from '@/components/questions/language'
import debounce from 'lodash.debounce'

// Quill editor
import { quillEditor } from 'vue-quill-editor'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'

export default {
  name: 'matter',
  components: {
    textQ: textQ,
    boolQ: boolQ,
    selectQ: selectQ,
    dateQ: dateQ,
    numberQ: numberQ,
    textareaQ: textareaQ,
    countryQ: countryQ,
    languageQ: languageQ,
    quillEditor
  },
  data () {
    return {
      matterId: this.$route.params.matter_id,
      visatype: false,
      matter: null,
      answers: {},
      secKey: 'notes',
      subcounts: {},
      files: {},
      notes: '',
      editorOptions: {
        placeholder: '',
        theme: 'snow',
        modules: {
          toolbar: [
            ['bold', 'italic', 'underline'],
            [{'list': 'ordered'}, {'list': 'bullet'}],
            [{'size': ['small', false, 'large', 'huge']}],
            [{'color': []}, {'background': []}],
            [{'font': []}],
            [{'align': []}],
            ['link', 'image'],
            ['clean']
          ]
        }
      }
    }
  },
  created: function () {
    axios.get('/api/matters/matterdata/' + this.matterId)
    .then(res => {
      if (res.status === 200) {
        this.matterData = res.data
        this.matter = res.data.matter
        this.notes = this.matter.notes
        this.visatype = res.data.visatype
        this.matter.subcounts = this.matter.subcounts || {}

        // Make a map of answer refs to sorted answers
        // TODO: will probably need to sort by num
        if (res.data.answers && res.data.answers.length) {
          res.data.answers.forEach(ans => {
            if (this.answers[ans.ref]) {
              this.answers[ans.ref].push(ans)
            } else {
              this.answers[ans.ref] = [ans]
            }
          })
        }

        // Initialise the subcounts dictionary
        this.visatype.sections.forEach(sec => {
          sec.subsections.forEach(sub => {
            this.subcounts[sub.ref] = this.matter.subcounts[sub.ref] || 1
          })
        })

        // Organise the files by doctype
        for (const f of this.matter.files) {
          if (this.files.hasOwnProperty(f.docref)) {
            this.files[f.docref].push(f)
          } else {
            this.files[f.docref] = [f]
          }
        }
      }
    })
    .catch(e => { console.log(e.response.data) })
  },
  computed: {
    section: function () {
      if (typeof this.secKey === 'number') {
        return this.visatype.sections[this.secKey]
      } else {
        return false
      }
    }
  },
  watch: {
    // Only update the file notes every xxx milliseconds
    notes: debounce(function () {
      this.saveNotes()
    }, 500)
  },
  methods: {
    // Return true if a sub or question should be shown
    visible: function (sub) {
      if (!sub.depends || !sub.depends.ref) return true // No dependencies -> show
      if (!this.answers[sub.depends.ref]) return false  // Unmet dependency -> hide
      var ans = this.answers[sub.depends.ref][0]        // TODO: might have to check all answers
      if (!ans) return false
      return ans.atxt === sub.depends.atxt
    },
    // Add a newly saved answer from a child component
    addAns: function (ans) {
      var array = this.answers[ans.ref]
      if (array) {
        array.splice(array.length, 0, ans)
      } else {
        this.answers[ans.ref] = [ans]
        this.answers = Object.assign({}, this.answers) // Force reactivity
      }
    },
    editAns: function (ans) {
      this.answers[ans.ref][ans.num - 1] = ans
      this.answers = Object.assign({}, this.answers)
    },
    addSub: function (sub) {
      this.subcounts[sub.ref] += 1
      this.subcounts = Object.assign({}, this.subcounts) // Must force reactivity
      this.matter.subcounts[sub.ref] = this.subcounts[sub.ref]
      axios.post('/api/matters/update', this.matter).catch(e => {
        console.log(e.response.data)
      })
    },
    showSub: function (sub) {
      if (!sub.depends || !sub.depends.ref) return true
      if (!this.answers[sub.depends.ref]) return false
      var ans = this.answers[sub.depends.ref][0]
      return ans && ans.atxt === sub.depends.atxt
    },
    dateStr (d) {
      return new Date(d).toDateString()
    },
    saveMatter () {
      axios.post('/api/matters/update', this.matter).catch(e => {
        console.log(e.response.data)
      })
    },
    saveNotes () {
      if (this.notes === this.matter.notes) return
      this.matter.notes = this.notes
      axios.post('/api/matters/updateNotes/' + this.matter._id, {notes: this.notes})
      .catch(e => {
        console.log(e.response.data)
      })
    }
  }
}
</script>

<style scoped>
.panel-docs {
  margin-top: 10px;
  padding-bottom: 10px;
}
.matterHeader .btn {
  padding: 0;
  margin: 0 0 1em 0;
}
i.icon.icon-back {
  margin: 0 7px 0 0;
  float: left;
  width: 26px;
  height: 26px;
  background-color: #ce4b81;
  border-radius: 2px;
  color: #fff;
}
.btn.btn-link span {
  float: left;
  padding: 3px 0 0 0;
  color: #ce4b81
}
.matterHolder {
  padding: 0 0 4em 0;
}
.btn.btn-link:hover i {
  background-color:  #b9336b;
}
.btn.btn-link:hover span {
  color:  #b9336b
}
.panel .btn.btn-sm {
    margin: 2em 0 1em 1em;
}
.panel .btn.btn-sm i {
    margin: 0 .5em 0 0;
}
</style>



// WEBPACK FOOTER //
// matter.vue?6d4089ec